import { createFileRoute, redirect } from "@tanstack/react-router";
import { fetchAuthSession } from "aws-amplify/auth";
import { WelcomePage } from "@/pages/Welcome/WelcomePage";

export const Route = createFileRoute("/welcome")({
  beforeLoad: async () => {
    try {
      const session = await fetchAuthSession();
      if (!session.tokens) throw redirect({ to: "/login" });
    } catch (e) {
      if (e instanceof Error && e.name !== "Error") throw e;
      throw redirect({ to: "/login" });
    }
  },
  component: WelcomePage,
});
